import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import PollChart from './PollChart';
import ExportPollResults from './ExportPollResults';
import store from "client/store";
import format from 'date-fns/format';

@observer
export default class PollResults extends React.Component {
	@observable fields;
	@observable data;
	@observable users;
	@observable tableData;

	constructor(props) {
		super(props);
		this.poll = props.poll;
		this.init();
	}

	init = async () => {
		const fields = await this.poll.fields();
		this.fields = fields && fields.length > 0 && fields;
		this.users =  await store.model.User.find();
		this.formatData();
	};

	formatData = () => {
		if (!this.fields) {
			return;
		}
		let total = 0;
		this.fields.forEach(field => (total += field.votes().length));

		this.tableData = this.fields.map((field) => {
		  return field.votes().map((vote) => {
		    return {
					label: field.user ? 'Свой вариант' : field.name,
					createdAt: vote.createdAt,
					owner: vote.ownerId ? this.getUsername(vote.ownerId) : vote.name,
					value: field.votes.length
				}
		  });
		}).flat(1).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

		const data = this.fields.map(field => {
			const name = field.user ? 'Свой вариант' : field.name;
			const votes = field.votes();
			const persent = ((votes.length * 100) / total).toFixed(1);
			return votes.length !== 0 && { label: name, id: `${name} (${persent} %)`, value: votes.length, votes };
		});
		this.data = data.filter(d => d);
	};

	getUsername = (id) => {
		const user = this.users.find((user) => user.id === id);
		return user ? user.firstName ? `${user.lastName} ${user.firstName} ${user.middleName}` : user.username : 'user';
	}

	render() {
		if (!this.fields || !this.data) {
			return null;
		}
		return (
			<div>
				<h3>Результаты голосования</h3>
				<p>{this.poll.name}</p>
				{this.data.length > 0 ? (
					<div className="poll-chart">
						<ExportPollResults poll={this.poll} excelData={this.tableData}/>
						{this.data && <PollChart data={this.data} />}
						<table className="poll-table">
							<thead>
								<tr>
									<th>Дата</th>
									<th>Имя пользователя</th>
									<th>Вариант ответа</th>
								</tr>
							</thead>
							<tbody>
								{this.tableData.map((vote) => {
											return (
												<tr key={vote.createdAt}>
													<td>{format(new Date(vote.createdAt), 'dd.MM.yyyy')}</td>
													<td>{vote.owner}</td>
													<td>{vote.label}</td>
												</tr>
											);
										})
									}
							</tbody>
						</table>
					</div>
				) : (
					<p>Голосов пока нет</p>
				)}
			</div>
		);
	}
}
